import Layout from "../../components/layout";
import amouzesh1 from "../../assets/images/amouzesh/1-min.jpg";
import amouzesh2 from "../../assets/images/amouzesh/2-min.jpg";
import amouzesh3 from "../../assets/images/amouzesh/3-min.jpg";
import amouzesh4 from "../../assets/images/amouzesh/4-min.jpg";

const Help = () => {
  return (
    <Layout>
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>راهنما</div>
          <div className='p-4'>
            <div>
              <img
                src={amouzesh1}
                alt='Amouzesh'
              />
            </div>
            <div>
              <img
                src={amouzesh2}
                alt='Amouzesh'
              />
            </div>
            <div>
              <img
                src={amouzesh3}
                alt='Amouzesh'
              />
            </div>
            <div>
              <img
                src={amouzesh4}
                alt='Amouzesh'
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Help;
